// The API's answer when it says no ("A second person must approve."), shown under a form.
import { errorText } from '@/lib/format'

export function ErrorText({ error }: { error: unknown }) {
  if (!error) return null
  return (
    <p className="field-error" role="alert" data-testid="form-error">
      {errorText(error)}
    </p>
  )
}
